import React from "react";
import styles from "./Modal.module.scss";
import cancel from "../../../../assets/images/close.png";
import customClose from "../../../../assets/images/closeIcon.png";

const Modal = (props) => {
  return (
    <div
      style={props.close ? { justifyContent: "center !important" } : {}}
      className={`modalOverlayWithBlur ${styles.container} ${props?.className}`}
    >
      {!props.close && (
        <button
          style={props?.preClassForcloseIcon??{}}
          className={props.close ? styles.customClose : styles.close}
          onClick={() => props.handleCloseAvatar()}
        >
          <img src={props.close ? customClose : cancel} alt="cancel" />
        </button>
      )}
      <div
        style={props.close ? { border: "3px solid #EB4547" } : {}}
        className={props.preDefineClassbox?styles.box:''}
      >
        {props.children}
      </div>
    </div>
  );
};

export default Modal;
